import api from './api';

export default {
  connection: async (abortController?: AbortController): Promise<any> => {
    return api.get(`custodia/connection`, { signal: abortController?.signal });
  },
};
